import { render, staticRenderFns } from "./dictDtl.vue?vue&type=template&id=188465cf&scoped=true&"
import script from "./dictDtl.vue?vue&type=script&lang=js&"
export * from "./dictDtl.vue?vue&type=script&lang=js&"
import style0 from "./dictDtl.vue?vue&type=style&index=0&id=188465cf&prod&lang=scss&scoped=true&"
import style1 from "./dictDtl.vue?vue&type=style&index=1&id=188465cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188465cf",
  null
  
)

export default component.exports